/**
 * Replaces an element in an array with another element at the specified position.
 *
 * @function
 * @param {Array<T>} array - The original array.
 * @param {number} position - The position at which to insert the new element.
 * @param {T} el - The new element to insert into the array.
 * @returns {Array<T>} A new array with the element replaced at the specified position.
 */
export const replaceElementInArray = <T>(array: Array<T>, position: number, element: T): Array<T> => {
  return [...array.slice(0, position), element, ...array.slice(position + 1)];
};
